import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-global space-y-8" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "flex divide-x" }
const _hoisted_4 = { class: "flex-1 flex-col space-y-6" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "flex space-x-12" }
const _hoisted_11 = { class: "flex flex-col" }

import BackButton from "@/components/common/BackButton.vue";
import { onMounted, reactive, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import SegmentedButtons from "@/components/common/SegmentedButtons.vue";
import Button from "@/components/common/Button.vue";
import Nomenclature from "@/types/documents/nomenclature/Nomenclature";
import { StatusesEnum } from "@/store";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { useStore } from "vuex";
import { NomenclatureActions } from "@/store/modules/nomenclature/actions";
import { NomenclatureGetters } from "@/store/modules/nomenclature/getters";
import { t } from "@/i18n";
import { getCommonStatusOptions } from "@/utils/labels";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();
const statuses = computed(() => getCommonStatusOptions());

const state = reactive<Nomenclature>({
  status: StatusesEnum.ACTIVE,
  name: "",
  index: "",
});
const rules = {
  status: { required },
  name: { required },
  index: { required },
};
const $externalResults = ref({});
const submitted = ref(false);
const v$ = useVuelidate(rules, state, { $externalResults });

async function handleSubmit(isFormValid: boolean) {
  submitted.value = true;
  if (!isFormValid) {
    return;
  }

  route.name === "NomenclatureEdit"
    ? await updateNomenclature()
    : await createNomenclature();
}

const createNomenclature = async () => {
  await store
    .dispatch(NomenclatureActions.CREATE, state)
    .then(async () => {
      await router.push({ name: "NomenclatureList" });
    })
    .catch((error) => {
      $externalResults.value = error.data.data;
    });
};

const updateNomenclature = async () => {
  await store
    .dispatch(NomenclatureActions.UPDATE, { id: state.id, data: state })
    .then(async () => {
      await router.push({ name: "NomenclatureList" });
    })
    .catch((error) => {
      $externalResults.value = error.data.data;
    });
};
if (route.name === "NomenclatureEdit") {
  onMounted(async () => {
    await store.dispatch(NomenclatureActions.FETCH_ONE, route.params.id);
    const nomenclature = store.getters[NomenclatureGetters.GET_CURRENT];
    state.id = nomenclature.id;
    state.name = nomenclature.name;
    state.status = nomenclature.status;
    state.index = nomenclature.index;
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButton, {
      to: { name: 'NomenclatureList' },
      class: "mb-4"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(route).name === "NomenclatureEdit"
          ? _unref(t)("nomenclatureForm.titleEdit")
          : _unref(t)("nomenclatureForm.titleCreate")), 1),
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", {
                class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).name.$invalid && submitted.value }])
              }, _toDisplayString(_unref(t)("common.title")), 3),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["input-form", {
                'p-invalid': _unref(v$).name.$invalid && submitted.value,
              }]),
                placeholder: _unref(t)('common.placeholderName'),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).name.$model) = $event))
              }, null, 10, _hoisted_6), [
                [_vModelText, _unref(v$).name.$model]
              ]),
              (_unref(v$).name.$externalResults.length > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(v$).name.$externalResults[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", {
                class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).index.$invalid && submitted.value }])
              }, _toDisplayString(_unref(t)("common.index")), 3),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["input-form", {
                'p-invalid': _unref(v$).index.$invalid && submitted.value,
              }]),
                placeholder: _unref(t)('common.placeholderName'),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).index.$model) = $event))
              }, null, 10, _hoisted_9), [
                [_vModelText, _unref(v$).index.$model]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", {
                  class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).status.$invalid && submitted.value }])
                }, _toDisplayString(_unref(t)("common.status")), 3),
                _createVNode(SegmentedButtons, {
                  class: _normalizeClass(["", {
                  'p-invalid': _unref(v$).status.$invalid && submitted.value,
                }]),
                  options: _unref(statuses),
                  modelValue: _unref(v$).status.$model,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).status.$model) = $event)),
                  required: ""
                }, null, 8, ["class", "options", "modelValue"])
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode(Button, { type: "submit" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$route.name === "NomenclatureEdit"
                  ? _unref(t)("nomenclatureForm.submitUpdateShort")
                  : _unref(t)("nomenclatureForm.submitCreateShort")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ], 32)
    ])
  ], 64))
}
}

})